function isTrueValue(v) {
  return String(v || "")
    .trim()
    .toLowerCase() === "true";
}

function safeGetItem(storage, key) {
  try {
    return storage?.getItem?.(key) ?? null;
  } catch {
    return null;
  }
}

function safeParseJson(raw) {
  try {
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function isMobileAppMode() {
  try {
    const fromMobileAppInUrl = isTrueValue(
      new URLSearchParams(window.location.search).get("fromMobileApp")
    );

    // Login in arrow_up_react sets this flag.
    const fromMobileAppInSessionFlag = isTrueValue(
      safeGetItem(window.sessionStorage, "fromMobileApp")
    );

    // Additional compatibility: some flows store it inside userData.
    const sessionUserData = safeParseJson(safeGetItem(window.sessionStorage, "userData"));
    const localUserData = safeParseJson(safeGetItem(window.localStorage, "userData"));

    const fromMobileAppInSessionUserData = isTrueValue(sessionUserData?.fromMobileApp);
    const fromMobileAppInLocalUserData = isTrueValue(localUserData?.fromMobileApp);

    return (
      fromMobileAppInUrl ||
      fromMobileAppInSessionFlag ||
      fromMobileAppInSessionUserData ||
      fromMobileAppInLocalUserData
    );
  } catch {
    return false;
  }
}

export function mobileNavigateBack() {
  try {
    window.GameStatus?.postMessage?.("navigate_back");
  } catch {
    /* ignore */
  }
}

